// Auto-generated from vocabulary.csv × audio/vocab — do not edit manually
// 334 cards, generated 2026-07-02
export const VOCAB_CARDS = [
  { key: "ai", jp: "あい", zh: "爱情", en: "love", romaji: "ai" },
  { key: "ame", jp: "あめ", zh: "雨", en: "rain", romaji: "ame" },
  { key: "ame2", jp: "あめ", zh: "糖果", en: "candy", romaji: "ame" },
  { key: "anata", jp: "あなた", zh: "你", en: "you", romaji: "anata" },
  { key: "bakajikara", jp: "ばかぢから", zh: "蛮力", en: "superhuman strength", romaji: "bakajikara" },
  { key: "bakudan", jp: "ばくだん", zh: "炸弹", en: "bomb", romaji: "bakudan" },
  { key: "bakuhatsu", jp: "ばくはつ", zh: "爆炸", en: "explosion", romaji: "bakuhatsu" },
  { key: "bara", jp: "ばら", zh: "玫瑰", en: "rose", romaji: "bara" },
  { key: "baribari", jp: "ばりばり", zh: "拼命地 / 不停地", en: "hard / energetically", romaji: "baribari" },
  { key: "benri", jp: "べんり", zh: "方便的", en: "convenient", romaji: "benri" },
  { key: "benkyō", jp: "べんきょう", zh: "学习", en: "study", romaji: "benkyō" },
  { key: "bero", jp: "べろ", zh: "舌头", en: "tongue", romaji: "bero" },
  { key: "betabeta", jp: "べたべた", zh: "黏糊糊的", en: "sticky", romaji: "betabeta" },
  { key: "bikkuri", jp: "びっくり", zh: "吃惊", en: "surprised", romaji: "bikkuri" },
  { key: "binbō", jp: "びんぼう", zh: "贫穷的", en: "poor", romaji: "binbō" },
  { key: "biyōn", jp: "びよーん", zh: "有弹性地", en: "stretchy", romaji: "biyōn" },
  { key: "biyouin", jp: "びよういん", zh: "美发店", en: "hair salon", romaji: "biyōin" },
  { key: "byouin", jp: "びょういん", zh: "医院", en: "hospital", romaji: "byōin" },
  { key: "bonyari", jp: "ぼんやり", zh: "模糊地", en: "vaguely", romaji: "bonyari" },
  { key: "boroboro", jp: "ぼろぼろ", zh: "破破烂烂", en: "tattered", romaji: "boroboro" },
  { key: "bosoboso", jp: "ぼそぼそ", zh: "嘀嘀咕咕/小声嘟囔", en: "mumbling", romaji: "bosoboso" },
  { key: "bōken", jp: "ぼうけん", zh: "冒险", en: "adventure", romaji: "bōken" },
  { key: "butchigiri", jp: "ぶっちぎり", zh: "遥遥领先", en: "far ahead", romaji: "butchigiri" },
  { key: "budō", jp: "ぶどう", zh: "葡萄", en: "grapes", romaji: "budō" },
  { key: "butsubutsu", jp: "ぶつぶつ", zh: "嘟囔地", en: "muttering", romaji: "butsubutsu" },
  { key: "butsukeru", jp: "ぶつける", zh: "碰上", en: "to bump into", romaji: "butsukeru" },
  { key: "chi", jp: "ち", zh: "血", en: "blood", romaji: "chi" },
  { key: "chijimu", jp: "ちぢむ", zh: "缩小", en: "to shrink", romaji: "chijimu" },
  { key: "chijirege", jp: "ちぢれげ", zh: "卷毛", en: "curly hair", romaji: "chijirege" },
  { key: "chijiremen", jp: "ちぢれめん", zh: "卷曲面", en: "curly noodles", romaji: "chijiremen" },
  { key: "chiisai", jp: "ちいさい", zh: "小的", en: "small", romaji: "chiisai" },
  { key: "chikyū", jp: "ちきゅう", zh: "地球", en: "Earth", romaji: "chikyū" },
  { key: "daiji", jp: "だいじ", zh: "重要的", en: "important", romaji: "daiji" },
  { key: "daisuki", jp: "だいすき", zh: "最喜欢", en: "love", romaji: "daisuki" },
  { key: "damaru", jp: "だまる", zh: "闭嘴", en: "to be silent", romaji: "damaru" },
  { key: "damasu", jp: "だます", zh: "骗", en: "to trick", romaji: "damasu" },
  { key: "deguchi", jp: "でぐち", zh: "出口", en: "exit", romaji: "deguchi" },
  { key: "dekiru", jp: "できる", zh: "能做到", en: "to be able to", romaji: "dekiru" },
  { key: "denki", jp: "でんき", zh: "电", en: "electricity", romaji: "denki" },
  { key: "densha", jp: "でんしゃ", zh: "电车", en: "train", romaji: "densha" },
  { key: "dondon", jp: "どんどん", zh: "越来越", en: "rapidly", romaji: "dondon" },
  { key: "doryoku", jp: "どりょく", zh: "努力", en: "effort", romaji: "doryoku" },
  { key: "dōga", jp: "どうが", zh: "视频", en: "video", romaji: "dōga" },
  { key: "dōro", jp: "どうろ", zh: "道路", en: "road", romaji: "dōro" },
  { key: "zuke", jp: "づけ", zh: "腌制的", en: "marinated", romaji: "zuke" },
  { key: "eiga", jp: "えいが", zh: "电影", en: "movie", romaji: "eiga" },
  { key: "eki", jp: "えき", zh: "车站", en: "station", romaji: "eki" },
  { key: "enogu", jp: "えのぐ", zh: "颜料", en: "paints", romaji: "enogu" },
  { key: "erabu", jp: "えらぶ", zh: "选择", en: "to choose", romaji: "erabu" },
  { key: "ewokaku", jp: "えをかく", zh: "画画", en: "to draw a picture", romaji: "ewokaku" },
  { key: "fueru", jp: "ふえる", zh: "增加", en: "to increase", romaji: "fueru" },
  { key: "fukai", jp: "ふかい", zh: "深的", en: "deep", romaji: "fukai" },
  { key: "futa", jp: "ふた", zh: "盖子", en: "lid", romaji: "futa" },
  { key: "fuyu", jp: "ふゆ", zh: "冬天", en: "winter", romaji: "fuyu" },
  { key: "gakkari", jp: "がっかり", zh: "失望", en: "disappointed", romaji: "gakkari" },
  { key: "gakkō", jp: "がっこう", zh: "学校", en: "school", romaji: "gakkō" },
  { key: "gaman", jp: "がまん", zh: "忍耐", en: "endurance", romaji: "gaman" },
  { key: "ganbaru", jp: "がんばる", zh: "努力", en: "to do my best", romaji: "ganbaru" },
  { key: "genkan", jp: "げんかん", zh: "门口", en: "entryway", romaji: "genkan" },
  { key: "genki", jp: "げんき", zh: "有精神的", en: "lively", romaji: "genki" },
  { key: "geragera", jp: "げらげら", zh: "哈哈大笑", en: "laughing loudly", romaji: "geragera" },
  { key: "gessori", jp: "げっそり", zh: "瘦弱", en: "gaunt", romaji: "gessori" },
  { key: "gin", jp: "ぎん", zh: "银", en: "silver", romaji: "gin" },
  { key: "ginkō", jp: "ぎんこう", zh: "银行", en: "bank", romaji: "ginkō" },
  { key: "girigiri", jp: "ぎりぎり", zh: "差一点", en: "just in time", romaji: "girigiri" },
  { key: "gogo", jp: "ごご", zh: "下午", en: "afternoon", romaji: "gogo" },
  { key: "gomakasu", jp: "ごまかす", zh: "欺骗", en: "to deceive", romaji: "gomakasu" },
  { key: "gomi", jp: "ごみ", zh: "垃圾", en: "trash", romaji: "gomi" },
  { key: "gorogoro", jp: "ごろごろ", zh: "滚来滚去", en: "idling around", romaji: "gorogoro" },
  { key: "gu", jp: "ぐ", zh: "配料", en: "ingredient", romaji: "gu" },
  { key: "gunte", jp: "ぐんて", zh: "棉纱手套", en: "work gloves", romaji: "gunte" },
  { key: "guruguru", jp: "ぐるぐる", zh: "转圈圈", en: "spinning around", romaji: "guruguru" },
  { key: "gūgū", jp: "ぐーぐー", zh: "咕噜咕噜", en: "growling", romaji: "gūgū" },
  { key: "gyutto", jp: "ぎゅっと", zh: "紧紧地", en: "tightly", romaji: "gyutto" },
  { key: "ha", jp: "は", zh: "牙齿", en: "tooth", romaji: "ha" },
  { key: "haha", jp: "はは", zh: "妈妈", en: "mother", romaji: "haha" },
  { key: "hairu", jp: "はいる", zh: "进", en: "to enter", romaji: "hairu" },
  { key: "hanaji", jp: "はなぢ", zh: "鼻血", en: "nosebleed", romaji: "hanaji" },
  { key: "hazukashii", jp: "はずかしい", zh: "害羞的", en: "embarrassed", romaji: "hazukashii" },
  { key: "henji", jp: "へんじ", zh: "回复", en: "reply", romaji: "henji" },
  { key: "heru", jp: "へる", zh: "减少", en: "to decrease", romaji: "heru" },
  { key: "heta", jp: "へた", zh: "不擅长的", en: "be bad at", romaji: "heta" },
  { key: "heya", jp: "へや", zh: "房间", en: "room", romaji: "heya" },
  { key: "hidoi", jp: "ひどい", zh: "过分的", en: "terrible", romaji: "hidoi" },
  { key: "hikaru", jp: "ひかる", zh: "发光", en: "to light up", romaji: "hikaru" },
  { key: "hiku", jp: "ひく", zh: "拉", en: "to pull", romaji: "hiku" },
  { key: "hitori", jp: "ひとり", zh: "一个人", en: "one person", romaji: "hitori" },
  { key: "hohoemu", jp: "ほほえむ", zh: "微笑", en: "to smile", romaji: "hohoemu" },
  { key: "honō", jp: "ほのお", zh: "火焰", en: "flame", romaji: "honō" },
  { key: "hontō", jp: "ほんとう", zh: "真实的", en: "real", romaji: "hontō" },
  { key: "honwoyomu", jp: "ほんをよむ", zh: "看书", en: "to read a book", romaji: "honwoyomu" },
  { key: "hoshi", jp: "ほし", zh: "星", en: "star", romaji: "hoshi" },
  { key: "iku", jp: "いく", zh: "去", en: "to go", romaji: "iku" },
  { key: "ima", jp: "いま", zh: "现在", en: "now", romaji: "ima" },
  { key: "isha", jp: "いしゃ", zh: "医生", en: "doctor", romaji: "isha" },
  { key: "itai", jp: "いたい", zh: "痛的", en: "hurt", romaji: "itai" },
  { key: "jikan", jp: "じかん", zh: "时间", en: "time", romaji: "jikan" },
  { key: "jishin", jp: "じしん", zh: "地震", en: "earthquake", romaji: "jishin" },
  { key: "jishin2", jp: "じしん", zh: "自信", en: "confidence", romaji: "jishin" },
  { key: "jūsho", jp: "じゅうしょ", zh: "地址", en: "address", romaji: "jūsho" },
  { key: "kaijū", jp: "かいじゅう", zh: "怪兽", en: "monster", romaji: "kaijū" },
  { key: "kaku", jp: "かく", zh: "写", en: "to write", romaji: "kaku" },
  { key: "kaku2", jp: "かく", zh: "抠", en: "to scratch", romaji: "kaku" },
  { key: "karai", jp: "からい", zh: "辣的", en: "spicy", romaji: "karai" },
  { key: "ke", jp: "け", zh: "毛", en: "hair", romaji: "ke" },
  { key: "keisatsu", jp: "けいさつ", zh: "警察", en: "police", romaji: "keisatsu" },
  { key: "keru", jp: "ける", zh: "踢", en: "to kick", romaji: "keru" },
  { key: "keshigomu", jp: "けしごむ", zh: "橡皮", en: "eraser", romaji: "keshigomu" },
  { key: "ki", jp: "き", zh: "树", en: "tree", romaji: "ki" },
  { key: "kinoko", jp: "きのこ", zh: "蘑菇", en: "mushroom", romaji: "kinoko" },
  { key: "kiru", jp: "きる", zh: "穿", en: "to put on", romaji: "kiru" },
  { key: "kiru2", jp: "きる", zh: "剪", en: "to cut", romaji: "kiru" },
  { key: "kodomo", jp: "こども", zh: "孩子", en: "child", romaji: "kodomo" },
  { key: "kōri", jp: "こおり", zh: "冰块", en: "ice", romaji: "kōri" },
  { key: "kōru", jp: "こおる", zh: "冻", en: "to freeze", romaji: "kōru" },
  { key: "korenanda", jp: "これなんだ", zh: "这是什么？", en: "What\'s this?", romaji: "korenanda" },
  { key: "kowai", jp: "こわい", zh: "可怕的", en: "scary", romaji: "kowai" },
  { key: "kuchi", jp: "くち", zh: "嘴", en: "mouth", romaji: "kuchi" },
  { key: "kujira", jp: "くじら", zh: "鲸", en: "whale", romaji: "kujira" },
  { key: "kusuri", jp: "くすり", zh: "药", en: "medicine", romaji: "kusuri" },
  { key: "kutsu", jp: "くつ", zh: "鞋子", en: "shoes", romaji: "kutsu" },
  { key: "mahō", jp: "まほう", zh: "魔法", en: "magic", romaji: "mahō" },
  { key: "mannaka", jp: "まんなか", zh: "中间", en: "center", romaji: "mannaka" },
  { key: "mayō", jp: "まよう", zh: "犹豫", en: "can’t decide", romaji: "mayō" },
  { key: "mazui", jp: "まずい", zh: "难吃的", en: "bad", romaji: "mazui" },
  { key: "me", jp: "め", zh: "眼睛", en: "eyes", romaji: "me" },
  { key: "me2", jp: "め", zh: "芽", en: "bud", romaji: "me" },
  { key: "mekuru", jp: "めくる", zh: "翻", en: "to turn over", romaji: "mekuru" },
  { key: "mezurashii", jp: "めずらしい", zh: "稀有的", en: "rare", romaji: "mezurashii" },
  { key: "mijikai", jp: "みじかい", zh: "短的", en: "short", romaji: "mijikai" },
  { key: "mimi", jp: "みみ", zh: "耳朵", en: "ear", romaji: "mimi" },
  { key: "mirai", jp: "みらい", zh: "未来", en: "future", romaji: "mirai" },
  { key: "miru", jp: "みる", zh: "看", en: "to look", romaji: "miru" },
  { key: "moguru", jp: "もぐる", zh: "潜水", en: "to dive", romaji: "moguru" },
  { key: "momo", jp: "もも", zh: "桃子", en: "peach", romaji: "momo" },
  { key: "momu", jp: "もむ", zh: "揉", en: "to rub", romaji: "momu" },
  { key: "morau", jp: "もらう", zh: "获得", en: "to get", romaji: "morau" },
  { key: "muku", jp: "むく", zh: "剥", en: "to peel off", romaji: "muku" },
  { key: "musubu", jp: "むすぶ", zh: "系（ji）", en: "to connect", romaji: "musubu" },
  { key: "musume", jp: "むすめ", zh: "女儿", en: "daughter", romaji: "musume" },
  { key: "muzukashii", jp: "むずかしい", zh: "难的", en: "difficult", romaji: "muzukashii" },
  { key: "nagai", jp: "ながい", zh: "长的", en: "long", romaji: "nagai" },
  { key: "nageru", jp: "なげる", zh: "扔", en: "to throw", romaji: "nageru" },
  { key: "naku", jp: "なく", zh: "哭", en: "to cry", romaji: "naku" },
  { key: "nande", jp: "なんで？", zh: "为什么？", en: "Why?", romaji: "nande" },
  { key: "nashi", jp: "なし", zh: "梨", en: "pear", romaji: "nashi" },
  { key: "nedan", jp: "ねだん", zh: "价格", en: "price", romaji: "nedan" },
  { key: "negau", jp: "ねがう", zh: "希望", en: "to hope", romaji: "negau" },
  { key: "nejiru", jp: "ねじる", zh: "拧", en: "to twist", romaji: "nejiru" },
  { key: "neru", jp: "ねる", zh: "睡觉", en: "to sleep", romaji: "neru" },
  { key: "nigai", jp: "にがい", zh: "苦的", en: "bitter", romaji: "nigai" },
  { key: "nigeru", jp: "にげる", zh: "逃", en: "to run away", romaji: "nigeru" },
  { key: "ninjin", jp: "にんじん", zh: "胡萝卜", en: "carrot", romaji: "ninjin" },
  { key: "niru", jp: "にる", zh: "煮", en: "to simmer", romaji: "niru" },
  { key: "noboru", jp: "のぼる", zh: "爬", en: "to climb", romaji: "noboru" },
  { key: "nori", jp: "のり", zh: "胶水", en: "glue", romaji: "nori" },
  { key: "noru", jp: "のる", zh: "坐", en: "to get on", romaji: "noru" },
  { key: "nō", jp: "のう", zh: "脑子", en: "brain", romaji: "nō" },
  { key: "nugu", jp: "ぬぐ", zh: "脱", en: "to take off", romaji: "nugu" },
  { key: "nureru", jp: "ぬれる", zh: "湿", en: "to get wet", romaji: "nureru" },
  { key: "nurie", jp: "ぬりえ", zh: "涂色画", en: "coloring pages", romaji: "nurie" },
  { key: "nū", jp: "ぬう", zh: "缝纫", en: "to sew", romaji: "nū" },
  { key: "odoru", jp: "おどる", zh: "跳", en: "to dance", romaji: "odoru" },
  { key: "oishii", jp: "おいしい", zh: "好吃的", en: "delicious", romaji: "oishii" },
  { key: "ōkami", jp: "おおかみ", zh: "狼", en: "wolf", romaji: "ōkami" },
  { key: "ōsama", jp: "おうさま", zh: "国王", en: "king", romaji: "ōsama" },
  { key: "pacchiri", jp: "ぱっちり", zh: "眼睛很大", en: "wide open (eyes)", romaji: "pacchiri" },
  { key: "pakupaku", jp: "ぱくぱく", zh: "大口大口地吃", en: "gobble up", romaji: "pakupaku" },
  { key: "paripari", jp: "ぱりぱり", zh: "酥脆的", en: "crispy", romaji: "paripari" },
  { key: "pasapasa", jp: "ぱさぱさ", zh: "干巴巴的", en: "dry", romaji: "pasapasa" },
  { key: "pekopeko", jp: "ぺこぺこ", zh: "鞠躬哈腰", en: "to grovel", romaji: "pekopeko" },
  { key: "perapera", jp: "ぺらぺら", zh: "流利", en: "fluently", romaji: "perapera" },
  { key: "peropero", jp: "ぺろぺろ", zh: "舔舔", en: "licking", romaji: "peropero" },
  { key: "pettanko", jp: "ぺったんこ", zh: "扁平的", en: "very flat", romaji: "pettanko" },
  { key: "pikapika", jp: "ぴかぴか", zh: "闪闪发亮的", en: "shiny", romaji: "pikapika" },
  { key: "piritto", jp: "ぴりっと", zh: "辣得刺激地", en: "spicy", romaji: "piritto" },
  { key: "pitatto", jp: "ぴたっと", zh: "紧贴地", en: "snugly", romaji: "pitatto" },
  { key: "pittari", jp: "ぴったり", zh: "正合适", en: "perfectly", romaji: "pittari" },
  { key: "pokapoka", jp: "ぽかぽか", zh: "暖洋洋", en: "warm and cozy", romaji: "pokapoka" },
  { key: "pokipoki", jp: "ぽきぽき", zh: "咔咔声", en: "cracking sound", romaji: "pokipoki" },
  { key: "ponkotsu", jp: "ぽんこつ", zh: "笨拙的", en: "useless", romaji: "ponkotsu" },
  { key: "potapota", jp: "ぽたぽた", zh: "掉落", en: "tears", romaji: "potapota" },
  { key: "pukapuka", jp: "ぷかぷか", zh: "漂浮地", en: "floating", romaji: "pukapuka" },
  { key: "pukkuri", jp: "ぷっくり", zh: "丰满的", en: "plump", romaji: "pukkuri" },
  { key: "punpun", jp: "ぷんぷん", zh: "生气", en: "angry", romaji: "punpun" },
  { key: "puripuri", jp: "ぷりぷり", zh: "弹牙的", en: "springy", romaji: "puripuri" },
  { key: "rainen", jp: "らいねん", zh: "明年", en: "next year", romaji: "rainen" },
  { key: "raku", jp: "らく", zh: "轻松的", en: "easy", romaji: "raku" },
  { key: "rakuda", jp: "らくだ", zh: "骆驼", en: "camel", romaji: "rakuda" },
  { key: "ranbō", jp: "らんぼう", zh: "乱暴的", en: "reckless", romaji: "ranbō" },
  { key: "reigi", jp: "れいぎ", zh: "礼貌", en: "manners", romaji: "reigi" },
  { key: "reizōko", jp: "れいぞうこ", zh: "冰箱", en: "refrigerator", romaji: "reizōko" },
  { key: "renzoku", jp: "れんぞく", zh: "连续性", en: "consecutively", romaji: "renzoku" },
  { key: "retsu", jp: "れつ", zh: "一排", en: "line", romaji: "retsu" },
  { key: "rippa", jp: "りっぱ", zh: "出色的", en: "impressive", romaji: "rippa" },
  { key: "riyū", jp: "りゆう", zh: "理由", en: "reason", romaji: "riyū" },
  { key: "rosenzu", jp: "ろせんず", zh: "线路图", en: "transit map", romaji: "rosenzu" },
  { key: "rōjin", jp: "ろうじん", zh: "老人", en: "elderly people", romaji: "rōjin" },
  { key: "rōka", jp: "ろうか", zh: "走廊", en: "hallway", romaji: "rōka" },
  { key: "rōsoku", jp: "ろうそく", zh: "蜡烛", en: "candle", romaji: "rōsoku" },
  { key: "rusu", jp: "るす", zh: "不在家", en: "away from home", romaji: "rusu" },
  { key: "rusuban", jp: "るすばん", zh: "看家", en: "house-sitting", romaji: "rusuban" },
  { key: "ryokō", jp: "りょこう", zh: "旅游", en: "trip", romaji: "ryokō" },
  { key: "ryōri", jp: "りょうり", zh: "做饭", en: "cooking", romaji: "ryōri" },
  { key: "sakana", jp: "さかな", zh: "鱼", en: "fish", romaji: "sakana" },
  { key: "saku", jp: "さく", zh: "开花", en: "to bloom", romaji: "saku" },
  { key: "samui", jp: "さむい", zh: "冷的", en: "cold", romaji: "samui" },
  { key: "sasu", jp: "さす", zh: "串", en: "to skewer", romaji: "sasu" },
  { key: "seki", jp: "せき", zh: "座位", en: "seat", romaji: "seki" },
  { key: "seki2", jp: "せき", zh: "咳嗽", en: "cough", romaji: "seki" },
  { key: "semai", jp: "せまい", zh: "窄的", en: "narrow", romaji: "semai" },
  { key: "sensei", jp: "せんせい", zh: "老师", en: "teacher", romaji: "sensei" },
  { key: "shio", jp: "しお", zh: "盐", en: "salt", romaji: "shio" },
  { key: "shiraberu", jp: "しらべる", zh: "调查", en: "to search", romaji: "shiraberu" },
  { key: "shizuka", jp: "しずか", zh: "安静的", en: "quiet", romaji: "shizuka" },
  { key: "shoppai", jp: "しょっぱい", zh: "咸的", en: "salty", romaji: "shoppai" },
  { key: "sodateru", jp: "そだてる", zh: "养", en: "to raise", romaji: "sodateru" },
  { key: "someru", jp: "そめる", zh: "染色", en: "to dye", romaji: "someru" },
  { key: "sora", jp: "そら", zh: "天空", en: "sky", romaji: "sora" },
  { key: "sōji", jp: "そうじ", zh: "打扫", en: "cleaning", romaji: "sōji" },
  { key: "suberu", jp: "すべる", zh: "滑", en: "to slide", romaji: "suberu" },
  { key: "suika", jp: "すいか", zh: "西瓜", en: "watermelon", romaji: "suika" },
  { key: "sukunai", jp: "すくない", zh: "少的", en: "few", romaji: "sukunai" },
  { key: "suwaru", jp: "すわる", zh: "坐", en: "to sit", romaji: "suwaru" },
  { key: "taberu", jp: "たべる", zh: "吃", en: "to eat", romaji: "taberu" },
  { key: "takai", jp: "たかい", zh: "高的", en: "high", romaji: "takai" },
  { key: "tamago", jp: "たまご", zh: "鸡蛋", en: "egg", romaji: "tamago" },
  { key: "tatsu", jp: "たつ", zh: "站起来", en: "to stand up", romaji: "tatsu" },
  { key: "tebukuro", jp: "てぶくろ", zh: "手套", en: "gloves", romaji: "tebukuro" },
  { key: "tezukuri", jp: "てづくり", zh: "手工制作", en: "handmade", romaji: "tezukuri" },
  { key: "tegami", jp: "てがみ", zh: "信", en: "letter", romaji: "tegami" },
  { key: "terasu", jp: "てらす", zh: "照亮", en: "to light up", romaji: "terasu" },
  { key: "tetsudau", jp: "てつだう", zh: "帮忙", en: "to help", romaji: "tetsudau" },
  { key: "tobu", jp: "とぶ", zh: "飞", en: "to fly", romaji: "tobu" },
  { key: "tomato", jp: "とまと", zh: "番茄", en: "tomato", romaji: "tomato" },
  { key: "tōi", jp: "とおい", zh: "远的", en: "far", romaji: "tōi" },
  { key: "toru", jp: "とる", zh: "拍", en: "to take", romaji: "toru" },
  { key: "tsuzuki", jp: "つづき", zh: "后续", en: "continuation", romaji: "tsuzuki" },
  { key: "tsuzuku", jp: "つづく", zh: "继续", en: "to continue", romaji: "tsuzuku" },
  { key: "tsukeru", jp: "つける", zh: "蘸", en: "to dip", romaji: "tsukeru" },
  { key: "tsuki", jp: "つき", zh: "月亮", en: "moon", romaji: "tsuki" },
  { key: "tsukue", jp: "つくえ", zh: "桌子", en: "table", romaji: "tsukue" },
  { key: "tsuyoi", jp: "つよい", zh: "强的", en: "strong", romaji: "tsuyoi" },
  { key: "un", jp: "うん", zh: "嗯", en: "Yeah", romaji: "un" },
  { key: "unko", jp: "うんこ", zh: "粑粑", en: "poop", romaji: "unko" },
  { key: "urusai", jp: "うるさい", zh: "吵闹的", en: "noisy", romaji: "urusai" },
  { key: "usagi", jp: "うさぎ", zh: "兔子", en: "rabbit", romaji: "usagi" },
  { key: "uso", jp: "うそ", zh: "谎言", en: "lie", romaji: "uso" },
  { key: "utau", jp: "うたう", zh: "唱", en: "to sing", romaji: "utau" },
  { key: "warau", jp: "わらう", zh: "笑", en: "to laugh", romaji: "warau" },
  { key: "warui", jp: "わるい", zh: "差的", en: "bad", romaji: "warui" },
  { key: "wasureru", jp: "わすれる", zh: "忘记", en: "to forget", romaji: "wasureru" },
  { key: "watashi", jp: "わたし", zh: "我", en: "me", romaji: "watashi" },
  { key: "yajirushi", jp: "やじるし", zh: "箭", en: "arrow", romaji: "yajirushi" },
  { key: "yaku", jp: "やく", zh: "烤", en: "to grill", romaji: "yaku" },
  { key: "yakusoku", jp: "やくそく", zh: "承诺", en: "promise", romaji: "yakusoku" },
  { key: "yasashii", jp: "やさしい", zh: "温柔的", en: "kind", romaji: "yasashii" },
  { key: "yogore", jp: "よごれ", zh: "污渍", en: "dirt", romaji: "yogore" },
  { key: "yorokobu", jp: "よろこぶ", zh: "高兴", en: "to be glad", romaji: "yorokobu" },
  { key: "yōji", jp: "ようじ", zh: "事情", en: "things to do", romaji: "yōji" },
  { key: "yowai", jp: "よわい", zh: "弱的", en: "weak", romaji: "yowai" },
  { key: "yuge", jp: "ゆげ", zh: "热气", en: "steam", romaji: "yuge" },
  { key: "yutaka", jp: "ゆたか", zh: "富裕的", en: "wealthy", romaji: "yutaka" },
  { key: "yūgata", jp: "ゆうがた", zh: "傍晚", en: "evening", romaji: "yūgata" },
  { key: "yūmei", jp: "ゆうめい", zh: "著名的", en: "famous", romaji: "yūmei" },
  { key: "zāzā", jp: "ざーざー", zh: "哗哗地", en: "pouring", romaji: "zāzā" },
  { key: "zairyō", jp: "ざいりょう", zh: "材料", en: "materials", romaji: "zairyō" },
  { key: "zannen", jp: "ざんねん", zh: "可惜的", en: "unfortunate", romaji: "zannen" },
  { key: "zawazawa", jp: "ざわざわ", zh: "嘈杂", en: "rustling", romaji: "zawazawa" },
  { key: "zeitaku", jp: "ぜいたく", zh: "奢侈的", en: "luxury", romaji: "zeitaku" },
  { key: "zenbu", jp: "ぜんぶ", zh: "全部", en: "all", romaji: "zenbu" },
  { key: "zenzen", jp: "ぜんぜん", zh: "完全不", en: "not at all", romaji: "zenzen" },
  { key: "zettai", jp: "ぜったい", zh: "绝对", en: "absolutely", romaji: "zettai" },
  { key: "zokuzoku", jp: "ぞくぞく", zh: "惊险", en: "thrilling", romaji: "zokuzoku" },
  { key: "zorozoro", jp: "ぞろぞろ", zh: "成群地", en: "in a line", romaji: "zorozoro" },
  { key: "zotto", jp: "ぞっと", zh: "心里一惊", en: "shudder", romaji: "zotto" },
  { key: "zō", jp: "ぞう", zh: "大象", en: "elephant", romaji: "zō" },
  { key: "zukei", jp: "ずけい", zh: "图形", en: "shape", romaji: "zukei" },
  { key: "zureru", jp: "ずれる", zh: "转移", en: "to shift", romaji: "zureru" },
  { key: "zurui", jp: "ずるい", zh: "狡猾的", en: "sneaky", romaji: "zurui" },
  { key: "zusshiri", jp: "ずっしり", zh: "重", en: "heavy", romaji: "zusshiri" },
];
